"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _loggers = require("customer-data-tracking/loggers");

var _ProfileIframeModal = _interopRequireDefault(require("crm_ui/profile/module/ProfileIframeModal"));

var _default = (0, _createReactClass.default)({
  displayName: 'ProfileIntegrationsIframeModal',
  propTypes: {
    activeIframe: _propTypes.default.shape({
      action: _propTypes.default.instanceOf(_immutable.Map).isRequired,
      parentTitle: _propTypes.default.string
    }).isRequired,
    appName: _propTypes.default.string.isRequired,
    closeIframeModal: _propTypes.default.func.isRequired
  },
  getTitle: function getTitle() {
    var activeIframe = this.props.activeIframe;
    return _I18n.default.text('profileSidebarModule.integrations.iframeTitle', {
      parentTitle: activeIframe.parentTitle,
      action: activeIframe.action.get('label')
    });
  },
  onDoneInterframeMessage: function onDoneInterframeMessage() {
    return _loggers.CrmLogger.log('recordUsage', {
      action: 'use linked sales object iframe action',
      type: this.props.appName
    });
  },
  render: function render() {
    var _this$props = this.props,
        activeIframe = _this$props.activeIframe,
        closeIframeModal = _this$props.closeIframeModal;
    return _react.default.createElement(_ProfileIframeModal.default, {
      closeIframeModal: closeIframeModal,
      height: activeIframe.action.get('height'),
      onDoneInterframeMessage: this.onDoneInterframeMessage,
      title: this.getTitle(),
      uri: activeIframe.action.get('uri'),
      width: activeIframe.action.get('width')
    });
  }
});

exports.default = _default;
module.exports = exports.default;